import * as selectors from './tabsSelectors';
import * as utils from './tabsUtils';

export { selectors, utils };
export { TabsEntryPoint } from './scope';
